import { CSSObject } from '@chakra-ui/react';
import { RaceTableSchema } from '@/views/races/RaceMeetings/RaceTable/styles/RaceTable/RaceTable.styles';

export const raceTableStyles: RaceTableSchema = {
  iconSvgMoneyBackProps: { color: 'alpha.400', mr: ['20', 0] },
  afterLinkRaceItemProps: { bg: [null, null, 'alpha.400'] },
};

export const FlexHeading: CSSObject = {
  bgGradient: 'linear(to-b, beta.300, beta.400)',
  borderTopRadius: 'base',
  color: 'alpha.800',
  top: ['12', '84px'],
  mb: '0',
  position: 'unset',
};

export const TextHeading: CSSObject = {
  fontFamily: 'Roboto',
  fontSize: 'sm',
  fontStyle: 'normal',
  fontWeight: 'semibold',
};

export const IconHeading: CSSObject = {
  boxSize: '8',
  color: 'beta.300',
  bgGradient: 'linear(to-b, alpha.500, alpha.700)',
  borderRadius: 'base',
  boxShadow:
    '0px 2px 5px 0px rgba(0, 0, 0, 0.25), 0px 1px 1px 0.5px #9F9CFD inset',
  p: '1.5',
  mr: '2',
};

export const BoxPageWrapper: CSSObject = {
  m: '0',
  mb: '4',
  bg: 'white',
  boxShadow: '0px 4px 2px 0px rgba(0, 0, 0, 0.25)',
  borderRadius: 'base',
};

export const BoxTableWrapper: CSSObject = {
  p: '0',
  borderBottomRadius: 'base',
};

export const TextVenueName: CSSObject = {
  fontWeight: 'medium',
  color: 'gray.700',
};

export const TextVenueCountry: CSSObject = {
  fontWeight: 'medium',
  color: 'alpha.400',
};

export const TextRaceResults: CSSObject = {
  color: 'gray.700',
};

export const BadgeRaceItem = ({ state }: any): CSSObject => ({
  borderRadius: 'base',
  bg: (() => {
    if (state === 'result') {
      return 'black';
    }
    return 'blackAlpha.400';
  })(),
});

export const LinkRaceItem = ({
  isToteMultiAvailable,
}: {
  isToteMultiAvailable?: boolean;
}) => ({
  bg: isToteMultiAvailable ? 'alpha.200' : 'transparent',
  borderLeft: 'none',
  borderTop: 'none',
  borderBottom: '1px solid',
  borderRightWidth: '1px',
  borderRightColor: 'gray.300',
  borderBottomColor: 'gray.300',
  _hover: {
    background: isToteMultiAvailable
      ? 'alpha.300'
      : ['transparent', null, 'white'],
  },
  _last: {
    borderRight: 'none',
  },
});

export const FlexRow: CSSObject = {
  bg: 'white',
  mb: '0',
  borderRadius: 'none',
  _last: {
    borderBottom: 'none',
  },
};

export const FlexButtonWrapper: CSSObject = {
  ml: 'auto',
  flexDir: 'column',
  columnGap: '4',
};

export const BoxVenueName: CSSObject = {
  bg: 'white',
  py: '1.5',
  borderColor: 'unset',
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: '1px solid',
  borderRightColor: 'gray.300',
  borderBottom: '1px solid',
  borderBottomColor: 'gray.300',
};

export const CenterTH = () => ({
  bg: 'alpha.500',
  color: 'white',
  textAlign: 'center',
  fontSize: '2xs',
  fontWeight: 'medium',
  py: '2.5',
  borderBottom: '1px',
  borderColor: 'gray.300',
});

export const ButtonChevron: CSSObject = {
  color: 'beta.400',
  bg: 'alpha.500',
  borderRadius: 'base',
  boxSize: '5',
  width: '7',
  _first: {
    '&&': {
      mb: '0.5',
    },
  },
};

export const BadgeRaceNumber: CSSObject = {
  bg: 'alpha.200',
  color: 'alpha.600',
  py: '1',
  borderRadius: 'base',
  h: '4',
};
